import toast from "src/swsh-native/toast";
import { setImageAsync } from "expo-clipboard";
import log from "src/helpers/log";
import CommonPrefetchedData from "../PrefetchedData/CommonPrefetchedData";

/**
 * Need to try safari first since it needs to be immediate
 */
const tryCopySafari = async (prefetchedData: CommonPrefetchedData) => {
	try {
		const contentType = "image/png";
		const makeImagePromise: Promise<Blob> = prefetchedData.blob();
		await navigator.clipboard.write([new ClipboardItem({ [contentType]: makeImagePromise })]);
		return { success: true };
	} catch (err) {
		return {
			success: false,
		};
	}
};

const tryCopyFallback = async (prefetchedData: CommonPrefetchedData) => {
	const contentType = await prefetchedData.contentType();
	const blob = await prefetchedData.blob();
	await navigator.clipboard
		.write([new ClipboardItem({ [contentType]: blob })])
		.catch(async (err) => {
			await setImageAsync(await prefetchedData.base64WithoutPrefix());
		});
};

/**
 * Web handling of copying to clipboard
 *
 * Firefox does not support the ClipboardItem constructor
 * Chrome works but rotates the image sometimes (exif issue)
 * Safari works
 */
const copyImageToClipboard = async (prefetchedData: CommonPrefetchedData) => {
	const { success } = await tryCopySafari(prefetchedData);
	if (success) return;
	try {
		await tryCopyFallback(prefetchedData);
	} catch (err) {
		log.error({ err }, "Error copying image");
		toast({
			preset: "error",
			title: "Error copying image",
			message: "Not supported in current browser",
		});
		throw err;
	}
};

export default copyImageToClipboard;
